import {InitialRequestUrl} from "@repo/shared-core";

/**
 * Parses a URL using the browser's built-in new URL(). Is also able to handle
 * relative URLs.
 *
 * @param {string} url The URL to parse.
 */
export const parseUrl = (url: string): URL =>
    new URL(url, InitialRequestUrl.origin);
